/**
 * Marketing-site deep links into ImageMotion.
 * Destinations are allowlisted. Never put personal data in the URL.
 */

export const POST_AUTH_NEXT_KEY = 'im_post_auth_next';

export const ALLOWED_NEXT = {
  new: 'NEW_PROJECT',
  dashboard: 'DASHBOARD',
  /** Opens the Staging Animation composer after sign-in. */
  staging: 'STAGING_ANIMATION',
} as const;

export type AllowedNext = keyof typeof ALLOWED_NEXT;
export type PostAuthView = (typeof ALLOWED_NEXT)[AllowedNext];

export function parseAllowedNext(raw: string | null): AllowedNext | null {
  if (!raw) return null;
  return raw in ALLOWED_NEXT ? (raw as AllowedNext) : null;
}

export function persistPostAuthNext(next: AllowedNext): void {
  try {
    sessionStorage.setItem(POST_AUTH_NEXT_KEY, next);
  } catch {
    /* ignore */
  }
}

export function readPostAuthNext(): AllowedNext | null {
  try {
    return parseAllowedNext(sessionStorage.getItem(POST_AUTH_NEXT_KEY));
  } catch {
    return null;
  }
}

export function clearPostAuthNext(): void {
  try {
    sessionStorage.removeItem(POST_AUTH_NEXT_KEY);
  } catch {
    /* ignore */
  }
}

export function viewForNext(next: AllowedNext | null): PostAuthView | null {
  if (!next) return null;
  return ALLOWED_NEXT[next];
}
